import React from 'react';
import { apiPost, hasPermission } from '../../../store/apiWrapper';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { popupActions } from '../../../store/popupStore';
import { reliabilityActions, RELIABILITY_SECTIONS } from '../../../store/reliabilityStore';
import { reportActions } from '../../../store/reportStore';
import { Translate, withLocalize } from 'react-localize-redux';
import { withRouter } from 'react-router';
import { writeErr } from '../../common/logger';
import BbPopover from '../../common/popover';
import CeeReportDateInformation from '../../search/cee/ceeReportDateInformation';
import Message from '../../common/message';
import Money from '../../common/moneyComponent';
import NoDataComponent from '../../common/noDataComponent';
import ReliabilityCEEStatus from './reliabilityCEEStatus';
import SvgRefresh from "../../../img/icons/Refresh";
import TableWrapper from '../../layoutItems/tableWrapper';

class ReliabilityCEE extends React.Component {

    state = {
        error: null
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.dataHash !== nextProps.dataHash || this.state !== nextState;
    }

    componentWillUnmount() {
        this.props.resetCeeAmlData();
    }

    render() {
        return isNullOrUndefined(this.props.data) ? <NoDataComponent /> : <div>{this.renderContent(this.props.data)}</div>;
    }

    renderContent = (data) => {
        const hasCeeDetailPermission = hasPermission(null, "CEEDetail");
        return (
            <ReliabilityCEEStatus
                data={data}
                dataHash={this.props.dataHash}
                onNotRequested={() => this.props.requestFetchSection([this.props.sectionId])}
                onInProgress={() => this.props.requestFetchSection([this.props.sectionId])}
            >
                {
                    this.state.error && <Message type="error" options={{ renderInnerHtml: true }}
                        message={this.props.translate(this.state.error.exception, this.state.error.exceptionData)}
                        shadowed style={{ marginBottom: '1em' }} />
                }
                <div className="aml-available" style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div style={{ display: "flex" }}>
                            <SvgRefresh className="refresh-icon" />
                            <BbPopover content={this.props.translate("Report.Reliability.Tooltip.UpdateData")} placement="right" targetId="reliability-cee-update-data" toggleOnEvent="toggleOnMouse" >
                                <div id="reliability-cee-update-data" onClick={() => this.updateData()}>
                                    <span className="link-internal">
                                        <Translate id="Search.Cee.UpdateData" />
                                    </span>
                                </div>
                            </BbPopover>
                        </div>
                        {
                            data.details.length > 0 &&
                            <div style={{ display: "flex", marginLeft: "2em" }}>
                                <SvgRefresh className="refresh-icon" />
                                <div style={{ justifyContent: "flex-start" }}
                                    className="link-internal"
                                    onClick={() => this.props.requestFetchSection([this.props.sectionId])}
                                >
                                    <Translate id="Reliability.Cee.UpdateData" />
                                </div>
                            </div>
                        }
                    </div>
                    <CeeReportDateInformation inserted={data.insertedFormatted} completed={data.completedFormatted} />
                </div>
                <div className="search-results-manager" style={{ fontWeight: "bold", paddingBottom: "1em", display: "flex", justifyContent: data.details.length > 0 ? "flex-end" : "flex-start" }}>
                    <div className='result-counts'>
                        <span><Translate id="Search.Cee.ResultCount" />:&nbsp;&nbsp;{data.details.length}</span>
                    </div>
                </div>
                {
                    data.details.length > 0 && <TableWrapper columns={6}>
                        <table className="table table-report-section-3">
                            <thead>
                                <tr>
                                    <th><span title={this.props.translate('Search.Cee.ExecutionInitiation.Description')}><Translate id="Search.Cee.ExecutionInitiation" /></span></th>
                                    <th><Translate id="Search.Cee.RegDate" /></th>
                                    <th><Translate id="Search.Cee.Name" /></th>
                                    <th><Translate id="Search.Cee.LastChangeDesc" /></th>
                                    <th style={{ textAlign: "right" }}>
                                        <Translate id="Search.Cee.MonetaryObligationCZ" />
                                    </th>
                                    <th><Translate id="Search.Cee.Cause.FileNo" /></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.details.map((d) => {
                                    return (<tr key={d.resultId}>
                                        <td>{d.courtOrderDateFormatted}</td>
                                        <td>{d.creationDateFormated}</td>
                                        <td>{d.name}</td>
                                        <td>{d.lastChange}</td>
                                        <td style={{ textAlign: "right" }}>
                                            {d.oneTimePrice ? <Money value={d.oneTimePrice} fractionDigits={2} /> : "-"}
                                        </td>
                                        <td>{d.exNumber}</td>
                                        <td>
                                            <div className="d-flex">
                                                <div className="d-inline-block text-center" style={{ flexBasis: "50%" }}>
                                                    {this.renderDetailLink(hasCeeDetailPermission, () => this.showPopup(false, d.causeId, d.exNumber, data.requestId))}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>)
                                })}
                            </tbody>
                        </table>
                    </TableWrapper>
                }
            </ReliabilityCEEStatus >
        )
    }

    updateData = () => this.props.requestCeeAmlData(this.props.id, () => { this.props.requestFetchSection([RELIABILITY_SECTIONS.cee]); this.props.requestFetchSection([RELIABILITY_SECTIONS.aml]) })

    renderDetailLink = (hasCeeDetailPermission, onDetailClick = () => { }) => {
        return (
            <span style={{ height: "2em", width: "2em", padding: "0", fontSize: "1.2em" }} className="link-functional" onClick={() => {
                if (!hasCeeDetailPermission)
                    this.onError({ exception: "UnhappyUser.NotAllowedAction" });
                else
                    onDetailClick();
            }}>
                <Translate id="Report.Detail" />
            </span>
        );
    }

    showPopup = (massRequest, causeId, exNumber, requestId) => {
        let causeIds = [causeId];
        this.props.showPopup('ceeDetailConfirmation', {
            title: this.props.translate('Search.Cee.Cause.Warning'),
            open: true,
            close: () => { this.props.hidePopup(); },
            no: () => this.props.hidePopup(),
            yes: () => this.submitSingle(requestId, causeIds[0]),
            data: {
                id: requestId,
                country: "CZ",
                option: "Search.Cee.Choose",
                count: 1,
                causeIds: causeIds,
                massRequest: massRequest,
                exNumber: exNumber
            }
        });
    }

    submitSingle = (id, causeId) => {
        let url = `${this.getBaseUrl(id)}/cause/${causeId}/detail`;
        let params = { isObligationRequest: true, country: "CZ", obligationCount: 0 };
        apiPost(url, params, null,
            (res) => {
                this.props.hidePopup();
                if (res.data.isSuccess)
                    this.onSuccess()
                else
                    this.onError({ exception: res.data.exception, exceptionData: res.data.exceptionData });
            },
            (err) => {
                this.props.hidePopup();
                writeErr(err);
                this.onError();
            }
        )
    }

    getBaseUrl = (id) => `${window.babylonApiUrl}/api/search/cee/requests/${id}`;
    onSuccess = () => this.props.requestFetchSection([this.props.sectionId]);
    onError = (error = null) => this.setState({ error: isNullOrUndefined(error) ? { exception: "Common.Error" } : error });
}

export default withLocalize(withRouter(connect(
    state => ({ ...state.report, reliability: state.reliability }),
    dispatch => bindActionCreators(Object.assign({}, reportActions, reliabilityActions, popupActions), dispatch)
)(ReliabilityCEE)));
